import './Header.css';
import React from 'react';

export default function Header({
  heightClass = 'h-[20vh]',
  whiteWidthClass = 'w-1/2',
  whiteHeightClass = 'h-[60%]',
  borderClass = 'border',
  children,
}) {
  return (
    <div
      className={`${heightClass} text-center border-b-2 border-gray-300 shadow-sm header-root`}
    >
      <div className="flex justify-center h-[50%]">
        <div
          className={`bg-black/95 rounded-xl ${whiteWidthClass} ${whiteHeightClass} shadow-none ${borderClass} flex items-center justify-center`}
        >
          {children}
        </div>
      </div>
    </div>
  );
}
